import {
  FEAASCDNStylesheetProps,
  fetchAndRevalidateStylesheet,
  getStylesheetURL,
  parseStylesheetSource,
  ValidatableStylesheetCallback
} from '../cdn.js'

export function renderStylesheet(props: FEAASCDNStylesheetProps, style?: HTMLStyleElement) {
  renderStylesheetPromise(props, (style ||= document.createElement('style')))
  return style
}

export function renderStylesheetPromise(props: FEAASCDNStylesheetProps, stylesheet?: HTMLStyleElement) {
  stylesheet ||= document.createElement('style')
  return fetchAndRevalidateStylesheet(props, (cssText, phase) => {
    stylesheet.textContent = cssText
  }).then(() => stylesheet)
}

const validatedStylesheets = new WeakSet<HTMLStyleElement | HTMLLinkElement>()
export function loadStylesheet(props: FEAASCDNStylesheetProps, callback?: ValidatableStylesheetCallback) {
  var writableStylesheet: HTMLStyleElement
  var foundStylesheet = findStylesheet(props)

  if (foundStylesheet) {
    if (validatedStylesheets.has(foundStylesheet)) {
      return Promise.resolve(foundStylesheet)
    }
    // it can be that page already have stylesheet using alternative URL (e.g. edge url), use that instead
    props = foundStylesheet.getAttribute('data-href') || foundStylesheet.getAttribute('href')
  }

  return fetchAndRevalidateStylesheet(props, (cssText, phase) => {
    // dont need to write stylesheet for cached state if we already found a stylesheet
    if (!(phase == 'initial' && foundStylesheet)) {
      writableStylesheet ||=
        !foundStylesheet || foundStylesheet.tagName == 'LINK' ? createStylesheet(props) : foundStylesheet
      writableStylesheet.textContent = cssText
    }
    callback?.(cssText, phase)
  }).then(() => writableStylesheet || foundStylesheet)
}

export function loadStylesheetAllowStale(props: FEAASCDNStylesheetProps) {
  return new Promise((resolve, reject) => {
    loadStylesheet(props, resolve).catch(reject)
  })
}

// Find stylesheet on the page for given props, also check by alternative edge url
export function findStylesheet(props: FEAASCDNStylesheetProps) {
  const cdnURL = getStylesheetURL(props)
  const { library } = parseStylesheetSource(cdnURL)
  const edgeURL = `/files/components/styles/${library}.css`
  return document.querySelector(
    `style[data-href="${cdnURL}"], 
    link[rel="stylesheet"][href="${cdnURL}"], 
    style[data-href*="${edgeURL}"], 
    link[rel="stylesheet"][href*="${edgeURL}"]`
  ) as HTMLStyleElement | HTMLLinkElement
}

export function createStylesheet(props: FEAASCDNStylesheetProps) {
  const url = getStylesheetURL(props)
  const stylesheet = document.createElement('style')
  stylesheet.setAttribute('data-href', url)
  document.head.appendChild(stylesheet)
  return stylesheet
}
